import React, { useEffect, useState } from 'react';
import {
  Box,
  SimpleGrid,
  useColorModeValue,
  Icon,
  Spinner,
  Center,
  useToast,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import axios from 'axios';

// Custom components
import MiniStatistics from 'components/card/MiniStatistics';
import IconBox from 'components/icons/IconBox';

// Icons
import { MdPeople, MdCategory } from 'react-icons/md';
import { FaBookOpen, FaMicrophone, FaMoneyBillWave } from 'react-icons/fa';

export default function UserReports() {
  const brandColor = useColorModeValue('#045e14', 'white');
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

  const toast = useToast();

  const baseUrl = (
    process.env.REACT_APP_BASE_URL || 'http://localhost:3030'
  ).replace(/\/$/, '');

  const token = localStorage.getItem('token');

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  // ✅ Updated state (Story system)
  const [dashboardData, setDashboardData] = useState({
    users: 0,
    categories: 0,
    stories: 0,
    audios: 0,
    payments: 0,
  });

  const [loading, setLoading] = useState(true);

  // 🔹 Fetch Dashboard Stats
  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        setLoading(true);

        const res = await axios.get(`${baseUrl}/api/admin/dashboard/stats`, {
          headers,
        });

        const data = res.data?.data || {};

        setDashboardData({
          users: data?.users ?? 0,
          categories: data?.categories ?? 0,
          stories: data?.stories ?? 0,
          audios: data?.audios ?? 0,
          payments: data?.payments ?? 0,
        });
      } catch (err) {
        console.error('Dashboard Stats Error:', err);

        toast({
          title: 'Failed to load dashboard stats',
          description: err.response?.data?.message || 'Server error',
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchDashboardStats();
    } else {
      toast({
        title: 'Unauthorized',
        description: 'Please login again',
        status: 'warning',
      });
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <Center pt="150px">
        <Spinner size="xl" thickness="4px" color="brand.500" />
      </Center>
    );
  }

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, '2xl': 5 }}
        gap="20px"
        mb="20px"
      >
        {/* USERS */}
        <Link to="/admin/users">
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon as={MdPeople} w="32px" h="32px" color={brandColor} />
                }
              />
            }
            name="Users"
            value={dashboardData.users}
          />
        </Link>

        {/* CATEGORIES */}
        <Link to="/admin/story-category">
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon as={MdCategory} w="32px" h="32px" color={brandColor} />
                }
              />
            }
            name="Categories"
            value={dashboardData.categories}
          />
        </Link>
        {/* ADMIN CONTENT MANAGER - Naya Card */}
<Link to="/admin/story-management-admin">
  <MiniStatistics
    startContent={
      <IconBox
        w="56px"
        h="56px"
        bg={boxBg}
        icon={
          <Icon
            as={FaBookOpen} // Aap koi bhi icon change kar sakte hain
            w="32px"
            h="32px"
            color="#4318FF" // Naya blue color
          />
        }
      />
    }
    name="Admin Content Upload"
    value="Upload Now" // Yahan aap "Add New" likh sakte hain
  />
</Link>

        {/* CHAPTERS */}
        <Link to="/admin/story-management">
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon as={FaBookOpen} w="32px" h="32px" color={brandColor} />
                }
              />
            }
            name="Story Management"
            value={dashboardData.stories}
          />
        </Link>

        {/* TOPICS */}
        <Link to="/admin/audio-studio">
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon
                    as={FaMicrophone}
                    w="32px"
                    h="32px"
                    color={brandColor}
                  />
                }
              />
            }
            name="Story Audio Studio"
            value={dashboardData.audios}
          />
        </Link>

        {/* PAYMENTS */}
        <Link to="/admin/payment">
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon
                    as={FaMoneyBillWave}
                    w="32px"
                    h="32px"
                    color={brandColor}
                  />
                }
              />
            }
            name="Payments"
            value={dashboardData.payments}
          />
        </Link>
      </SimpleGrid>
    </Box>
  );
}

